export default __webpack_public_path__ + "static/media/test_end_all_background.ec3ac129.jpg";